import React from 'react';
import FileUploadReportForm from '../FileUploadReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const FaceLivenessV4InputComponent = () => (
    <FileUploadReportForm
        banner={{ icon: 'pi-eye', title: 'Face Liveness (v4)', subtitle: 'v4 liveness check via Surepass' }}
        fileFields={[
            { name: 'file', label: 'Face image', accept: 'image/*', maxSizeBytes: 5 * 1024 * 1024, hint: 'JPG / PNG up to 5 MB', colClass: 'col-12 md:col-8 lg:col-6' },
        ]}
        endpoint={{ path: '/surepass/face/liveness-v4' }}
        consentReportType="face-liveness"
        submitLabel="Run Liveness Check"
        successSummary="Liveness v4 check complete"
        errorSummary="Liveness v4 check failed"
        confirmHeader="Confirm liveness v4 check"
        confirmAcceptLabel="Yes, check"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Face Liveness v4 Result', icon: 'pi-eye' }}
    />
);

export default FaceLivenessV4InputComponent;
